<template>
  <div class="row justify-content-center">
    <home-header></home-header>
    <vs-prompt
      title=""
      @accept="deleteActivity"
      accept-text="ลบ"
      cancel-text="ยกเลิก"
      @close="close"
      :active.sync="deletePrompt"
    >
      <div class="con-exemple-prompt">ลบข้อมูลนี้?</div>
    </vs-prompt>

    <vs-prompt
      color="primary"
      title="แจ้งเปิดปิดบ้าน"
      accept-text="บันทึก"
      cancel-text="ยกเลิก"
      @cancel="
        (formModel.range.start = ''),
          (formModel.range.end = ''),
          (formModel.desc = '')
      "
      @accept="saveCloseHouse"
      @close="close"
      :is-valid="validName"
      :active.sync="activePrompt2"
    >
      <div class="con-exemple-prompt">
        กรุณาเลือกวันที่ที่ต้องการปิดบ้านพร้อมแจ้งรายละเอียด <br /><br />
        <!-- <DatePicker v-model="formModel.dttm" /> -->

        <DatePicker
          :open-date="new Date()"
          is-expanded
          locale="th"
          v-model="formModel.range"
          is-range
        />

        <!-- <v-date-picker v-model="range" is-range /> -->
        <!-- <datepicker
          :highlighted="highlightedFn"
          icon="event"
          name="dttm"
          placeholder="วันที่"
          :language="languages['th']"
          format="d MMMM yyyy"
          v-model="formModel.dttm"
        ></datepicker> -->

        <!-- <vs-input icon="event" placeholder="วันที่" v-model="formModel.dttm"/> -->

        <vs-textarea
          icon="mode_edit"
          placeholder="รายละเอียด"
          v-model="formModel.desc"
          style="margin-top: 6px"
        />

        <vs-alert :active="!validName" color="danger" icon="new_releases">
          กรุณากรอกข้อมูลให้ครบถ้วน
        </vs-alert>
      </div>
    </vs-prompt>
    <div v-if="enable">
      <vs-list>
        <vs-list-item class="k-nav-bar" title="เปิดปิดบ้าน" subtitle="">
          <vs-button @click="activePrompt2 = true" color="primary" type="filled"
            >แจ้งปิดบ้าน</vs-button
          >
        </vs-list-item>
      </vs-list>
      <vs-card style="margin-top: 10px">
        <div>
          <vs-table stripe :data="activityItems">
            <template slot="thead" style="margin-top: 100px">
              <vs-th> ลบ </vs-th>
              <vs-th> จากวันที่ </vs-th>
              <vs-th> ถึงวันที่ </vs-th>
              <vs-th> รายละเอียด </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <vs-button
                    @click="openDeletePromt(data[indextr].key)"
                    color="primary"
                    type="flat"
                    icon="delete"
                  ></vs-button>
                </vs-td>
                <vs-td :data="data[indextr].date_start">
                  {{
                    new Date(data[indextr].date_start.seconds * 1000)
                      | moment("dddd, Do MMMM YYYY")
                  }}
                </vs-td>
                <vs-td :data="data[indextr].date_stop">
                  {{
                    new Date(data[indextr].date_stop.seconds * 1000)
                      | moment("dddd, Do MMMM YYYY")
                  }}
                </vs-td>
                <vs-td :data="data[indextr].desc">
                  {{ data[indextr].desc }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
      <div>
        <br />
        <paginate
          v-model="page"
          :page-count="total"
          :page-range="3"
          :margin-pages="2"
          :click-handler="inputData"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
    </div>
    <div v-else>
      <the-advertising :post-details="listAdvertising" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueCryptojs from "vue-cryptojs";
import VueCookies from "vue-cookies";
import { db } from "../store/firebaseDb";
const moment = require("moment");
require("moment/locale/th");
// import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import HomeHeader from "@/layouts/components/custom/HomeHeader.vue";
import Paginate from "vuejs-paginate";
import TheAdvertising from "@/components/advertising/TheAdvertising.vue";
import ListAdvertising from "@/store/listAdvertising.js";
import { Calendar, DatePicker } from "v-calendar";
console.log("lang", lang);

Vue.use(VueCryptojs);
Vue.use(VueCookies);
Vue.component("home-header", HomeHeader);
Vue.component("paginate", Paginate);
Vue.component("the-advertising", TheAdvertising);

moment.locale("th");
Vue.use(require("vue-moment"), {
  moment,
});

console.log(Vue.moment().locale());
export default {
  data() {
    return {
      date: new Date(),
      deletePrompt: false,
      language: "en",
      languages: lang,
      houseInfo: {},
      activityItems: [],
      activePrompt2: false,

      val: "",
      hNumber: "",
      formModel: {
        desc: "",
        range: {
          start: new Date(),
          end: new Date(),
        },
      },
      highlightedFn: {
        customPredictor(date) {
          const now = moment(new Date()).format("MMMM Do YYYY");
          const d = moment(date).format("MMMM Do YYYY");
          console.log("now=", now);
          console.log("d=", d);
          if (now == d) {
            return true;
          }
        },
      },
      // pagination
      total: 0, // จำนวนหน้า
      page: 1,
      totalItems: 0, // จำนวนข้อมูลทั้งหมด
      isLoad: true,
      user_cloud_config: {},
      enable: null,
      listAdvertising: {},
      show_per_page: 10,
      attrs: [
        {
          // key: 'today',
          // highlight: 'red',
          // dates: new Date(),
        },
      ],
    };
  },
  computed: {
    disabledDates() {
 return {
          disabledDates: ['2017-08-18']
        }
    // return {to: new Date(2022, 5, 2)};

    },
    validName() {
      console.log("validName=", this.formModel);
      return (
        this.formModel.range.start !== null &&
        this.formModel.range.end !== null &&
        this.formModel.desc.length > 0
      );
    },
  },
  methods: {
    documentPath() {
      const customerName = $cookies.get("customer");
      const _documentPath = "customer/" + customerName + "/activity";
      return _documentPath;
    },

    isHavePrefixAdddress() {
      return !(
        this.houseInfo.prefix_address == null ||
        this.houseInfo.prefix_address == ""
      );
    },

    deleteActivity() {
      const customerName = $cookies.get("customer");
      db.collection(this.documentPath())
        .doc(this.deleteId)
        .delete()
        .then(() => {
          console.log("Document deleted!");
          this.getTotalRow();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    openDeletePromt(id) {
      this.deleteId = id;
      this.deletePrompt = true;
    },

    saveCloseHouse() {
      console.log("[[saveCloseHouse]]");

      this.hNumber = $cookies.get("home");

      this.formModel.house_no = this.hNumber;
      this.formModel.type = 0;
      this.formModel.subtitle = "";
      this.formModel.title = "";
      this.formModel.activity = "";

      // this.formModel.range.start = null;
      // this.formModel.range.end = null;

      if (this.formModel.range.start < this.formModel.range.end) {
        this.formModel.date_start = this.formModel.range.start;
        this.formModel.date_stop = this.formModel.range.end;
      } else {
        this.formModel.date_start = this.formModel.range.end;
        this.formModel.date_stop = this.formModel.range.start;
      }

      this.formModel.date_start.setHours(0);
      this.formModel.date_start.setMinutes(0);
      this.formModel.date_start.setSeconds(0);

      this.formModel.date_stop.setHours(23);
      this.formModel.date_stop.setMinutes(59);
      this.formModel.date_stop.setSeconds(59);

      delete this.formModel.range;

      if (this.isHavePrefixAdddress()) {
        this.formModel.prefix_address = this.houseInfo.prefix_address;
      } else {
        this.formModel.prefix_address = "";
      }

      console.log("this.formModel=", this.formModel);

      // event.preventDefault();
      db.collection(this.documentPath())
        .doc()
        .set(this.formModel)
        .then(() => {
          this.formModel.range = {
            start: new Date(),
            end: new Date(),
          };

          delete this.formModel.date_start;
          delete this.formModel.date_stop;

          this.formModel.desc = "";

          this.getTotalRow();

          this.$vs.notify({
            color: "danger",
            title: "",
            text: "บันทึกข้อมูลสำเร็จแล้ว",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    close() {
      this.formModel.range.start = null;
      this.formModel.range.end = null;

      this.formModel.desc = "";
    },

    async getLastItem() {
      console.log("[[getLastItem]]");

      const _limit = (this.page - 1) * this.show_per_page;
      console.log("this.page=" + this.page);
      console.log("this.show_per_page=" + this.show_per_page);
      console.log("_limit=" + _limit);

      if (_limit === 0) return null;

      this.hNumber = $cookies.get("home");
      let reference = null;

      if (this.isHavePrefixAdddress()) {
        reference = db
          .collection(this.documentPath())
          .where("house_no", "==", this.hNumber + "")
          .where("prefix_address", "==", this.houseInfo.prefix_address + "");
      } else {
        reference = db
          .collection(this.documentPath())
          .where("house_no", "==", this.hNumber + "")
          .where("prefix_address", "==", "");
      }

      reference = reference.orderBy("date_start", "desc");
      reference = reference.limit(_limit);

      const snapshot = await reference.get();
      console.log("snapshot.docs.length=" + snapshot.docs.length);

      const last = snapshot.docs[snapshot.docs.length - 1];
      return last;
    },

    async getTotalRow() {
      let totalCustomer = await this.getDbWithCondition(true, null)
        .get()
        .then((document) => document.docs.length);

      console.log("totalCustomer=" + totalCustomer);

      this.total = Math.ceil(totalCustomer / this.show_per_page);
      this.totalItems = totalCustomer;
    },

    getDbWithCondition(isForCountAll = false, lastItem) {
      console.log("[[getDbWithCondition]]");

      this.hNumber = $cookies.get("home");
      let reference = null;

      if (this.isHavePrefixAdddress()) {
        reference = db
          .collection(this.documentPath())
          .where("house_no", "==", this.hNumber + "")
          .where("prefix_address", "==", this.houseInfo.prefix_address + "");
      } else {
        reference = db
          .collection(this.documentPath())
          .where("house_no", "==", this.hNumber + "")
          .where("prefix_address", "==", "");
      }

      if (isForCountAll == true) {
        return reference;
      }

      reference = reference.orderBy("date_start", "desc");

      console.log("this.show_per_page=" + this.show_per_page);

      if (lastItem != null) {
        reference = reference.startAfter(lastItem).limit(this.show_per_page);
      } else {
        reference = reference.limit(this.show_per_page);
      }

      return reference;
    },

    async listActivity({ page = 1 }) {
      console.log("page=" + page);

      this.isLoad = true;

      this.getTotalRow();

      this.getLastItem().then((lastItem) => {
        console.log("lastItem", lastItem);

        this.getDbWithCondition(false, lastItem).onSnapshot(
          (snapshotChange) => {
            this.activityItems = [];

            snapshotChange.forEach((doc) => {
              this.activityItems.push({
                key: doc.id,
                activity: doc.data().activity,
                desc: doc.data().desc,
                date_start: doc.data().date_start,
                date_stop: doc.data().date_stop,
              });

              this.isLoad = false;
            });
          }
        );
      });
      // console.log("last=",last);
    },

    previousData: function () {
      this.listActivity({ page: this.page });
    },
    nextData: function () {
      this.listActivity({ page: this.page });
    },
    inputData: function (value) {
      this.page = value;
      this.listActivity({ page: this.page });
    },
  },
  components: {
    Calendar,
    DatePicker,
  },
  created() {
    this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    var parameters = this.$route.query;

    var home = $cookies.get("home");
    console.log("home", home);

    this.houseInfo = $cookies.get("houseinfo");
    this.hNumber = $cookies.get("home");
    console.log("this.houseInfo=", this.houseInfo);
    if (
      typeof this.houseInfo.active !== "undefined" ||
      this.houseInfo.active !== null
    ) {
      console.log("this.houseInfo.active => ", this.houseInfo.active);
      if (this.houseInfo.active === false) {
        this.$vs.notify({
          title: "<center>VCar Park</center>",
          text: "ไม่มี สิทธิ์ใช้งานส่วนเสริม",
          color: "danger",
          position: "top-center",
        });
        setTimeout(() => this.$router.push({ path: "/pages/error-403" }), 2000);
      }
    }

    this.listActivity({ page: this.page });
    this.user_cloud_config = $cookies.get("user_cloud_config");

    this.enable = this.user_cloud_config.enable_close_house;
    this.listAdvertising = ListAdvertising.page_close_home;
  },
};
</script>

<style>
.con-exemple-prompt {
  padding: 10px;
  padding-bottom: 0px;
}
.vs-input {
  width: 100%;
  margin-top: 10px;
}

.pagination .prev-class {
  background-color: red;
}
.page-item {
  color: red;
}
</style>
